export class CppDeliveryInstructionsData {
  id: number;
  packagedType: string;
  contactType: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  lineErrors = new LineError();
  lineError = false;
  toBeValidated = false;
  isActive = false;
  contactId: number;
  selectedDeliveryInstructions: any;
  deliveryInstructions: string = '';
  isDeliveryInstructionsDisabled: boolean = true;
  packagedTypeDisabled: boolean = true;
}

export class LineError {
  itemId: number;
  errors: Array<string> = [];
}
export class CppDeliveryInstructionFormsData {
  accountNumber: number;
  updatedBy: string;
  dateUpdated: string;
  deliveryInstructionsData: Array<CppDeliveryInstructionsData> = [];
}
// Class model for delivery instruction master drop down
export class CppDeliveryInstructionMaster {
  DeliveryCode: string;
  Description: string;
}

// Class model for delivery instruction master drop down
export class CppDeliveryInstructionProductLine {
  ProductLineId: string;
  Description: string;
}
export var ContactType = [{ id: 'P', value: 'Primary' }, { id: 'S', value: 'Secondary' }];
